export const CONTAINER_MAX_WIDTH = 'max-w-[430px] md:max-w-[480px] lg:max-w-[520px]';

export const HORIZONTAL_PADDING = 'px-6 sm:px-8 md:px-10 lg:px-12';

export const HORIZONTAL_INSET_LEFT = 'left-8 sm:left-8 md:left-10 lg:left-12';
export const HORIZONTAL_INSET_RIGHT = 'right-8 sm:right-8 md:right-10 lg:right-12';

export const TYPOGRAPHY = {
  title: 'text-[30px] md:text-[32px] lg:text-[32px]',
  description: 'text-[14px] md:text-[15px] lg:text-[16px]',
  button: 'text-[12px]',
} as const;

export const ILLUSTRATION = {
  containerHeight: 'h-[280px] xs:h-[400px] sm:h-[430px] md:h-[457px]',
  cloudWidth: 'w-[110px] xs:w-[194px] sm:w-[194px] md:w-[194px]',
  cloudHeight: 'h-[71px] xs:h-[126px] sm:h-[135px] md:h-[148px]',
  starWidth: 'w-[42px] xs:w-[68px] sm:w-[68px] md:w-[68px]',
  starHeight: 'h-[43px] xs:h-[69px] sm:h-[74px] md:h-[81px]',
} as const;

export const SPACING = {
  logoTop: 'mt-[20px] xs:mt-[28px] sm:mt-[34px] md:mt-[40px]',
  logoWidth: 'w-[100px] xs:w-[108px] sm:w-[115px] md:w-[125px]',
  illustrationTop: 'mt-[30px] xs:mt-[30px] sm:mt-[34px] md:mt-[34px]',
  textBottom: 'mb-3 sm:mb-4',
  buttonsBottom: 'pb-8 sm:pb-10 md:pb-12',
  buttonGap: 'space-y-2',
} as const;

export const BUTTON_HEIGHT = 'h-12 md:h-14';

export const EMAIL_ILLUSTRATION = {
  containerHeight: 'h-[180px] xs:h-[200px] sm:h-[220px] md:h-[240px]',
  cloudGroupWidth: 'w-[190px] xs:w-[220px] sm:w-[220px] md:w-[241px]',
  leftDecorWidth: 'w-[38px] xs:w-[44px] sm:w-[47px]',
  leftDecorTop: 'top-[48px] xs:top-[82px] sm:top-[18px] md:top-[20px]',
  leftDecorLeft: 'left-[8px] xs:left-[12px] sm:left-[16px] md:left-[20px]',
  upperRightDecorWidth: 'w-[28px] xs:w-[32px] sm:w-[32px]',
  upperRightDecorTop: 'top-[0px] xs:top-[4px] sm:top-[6px] md:top-[8px]',
  upperRightDecorRight: 'right-[54px] xs:right-[50px] sm:right-[16px] md:right-[20px]',
  horizontalInsetLeft: 'left-7 sm:left-8 md:left-10 lg:left-12',
  horizontalInsetRight: 'right-8 sm:right-8 md:right-10 lg:right-12',
} as const;

export const EMAIL_SPACING = {
  illustrationTop: 'mt-[30px] xs:mt-[40px] sm:mt-[50px] md:mt-[58px]',
  formGap: 'gap-5 sm:gap-6',
  inputHeight: 'h-12 md:h-14',
} as const;

export const EMAIL_TYPOGRAPHY = {
  input: 'text-sm md:text-[15px]',
  helper: 'text-sm md:text-[15px]',
  error: 'text-sm',
} as const;

export const CHECK_EMAIL_ILLUSTRATION = {
  containerHeight: 'h-[160px] xs:h-[180px] sm:h-[200px] md:h-[220px]',
  cloudGroupWidth: 'w-[260px] xs:w-[280px] sm:w-[280px] md:w-[320px]',
} as const;

export const CHECK_EMAIL_SPACING = {
  illustrationTop: 'mt-[20px] xs:mt-[30px] sm:mt-[40px] md:mt-[48px]',
  contentGap: 'gap-4 sm:gap-5',
  secondaryButtonTop: 'mt-2 sm:mt-2 md:mt-4',
} as const;
